import React from "react";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <section
      id="iletisim"
      data-testid="contact-section"
      className="bg-slate-50 py-20 lg:py-28 border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Heading column */}
          <div className="lg:col-span-12 mb-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-tick"></span>
              <span className="overline">İLETİŞİM / TEKLİF</span>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight max-w-3xl"
              style={{ fontFamily: "Outfit" }}
            >
              Hızlıca teklif alın.
              <br />
              <span className="text-cyan-600">Genellikle 24 saat içinde dönüş.</span>
            </h2>
          </div>

          {/* Form */}
          <div className="lg:col-span-8">
            <QuoteForm />
          </div>

          {/* Quick contact */}
          <div className="lg:col-span-4 space-y-5">
            <div className="ind-card p-7 bg-slate-900 text-white">
              <div className="font-mono-accent text-xs text-cyan-400 tracking-[0.22em] uppercase mb-4">
                Hızlı İletişim
              </div>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <Phone className="w-4 h-4 mt-0.5 text-cyan-400" />
                  <a
                    href={SITE.phoneHref}
                    data-testid="quick-contact-phone"
                    className="hover:text-cyan-300"
                  >
                    {SITE.phone}
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Mail className="w-4 h-4 mt-0.5 text-cyan-400" />
                  <a
                    href={SITE.emailHref}
                    data-testid="quick-contact-email"
                    className="hover:text-cyan-300"
                  >
                    {SITE.email}
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 text-cyan-400" />
                  <span>{SITE.address}</span>
                </li>
              </ul>
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="quick-contact-whatsapp"
                className="btn-whatsapp w-full mt-6"
              >
                <MessageCircle className="w-4 h-4" /> Hemen WhatsApp'tan Yaz
              </a>
            </div>

            <div className="ind-card p-7 bg-stripes">
              <div className="text-xs font-mono-accent text-cyan-700 tracking-[0.22em] uppercase mb-2">
                Acil mi?
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">
                Plansız duruş yaşıyorsanız doğrudan WhatsApp veya telefon hattını
                kullanın — en kısa sürede saha ekibi yönlendirilir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
